module.exports = __webpack_public_path__ + "img/icon_5_36.11f28d2f.png";